import { useNavigate } from "react-router-dom";
import "./addCars.scss";

import AddIcon from "../../assets/Icon/add.svg";

import { Card, Text } from "../Index";

// Reusable "Add Vehicle" trigger card.
// Fully clickable: the whole Card navigates to the existing
// vehicle registration page (/AddCars) — no duplicate form/page.
// Width matches the car cards exactly by reusing Card size="full"
// (width 84%, margin auto) inside the same containing block.
function AddCars() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/AddCars");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleNavigate();
    }
  };

  return (
    <Card
      size="full"
      className="add-vehicle-card"
      onClick={handleNavigate}
      onKeyDown={handleKeyDown}
      role="link"
      tabIndex={0}
      aria-label="ثبت خودرو جدید"
    >
      <img
        src={AddIcon}
        alt=""
        aria-hidden="true"
        className="add-vehicle-card__icon"
      />

      <Text
        FontWight="Bold"
        FontSize="md"
        position="center"
      >
        ثبت خودرو جدید
      </Text>
    </Card>
  );
}
export default AddCars;
